import { render } from "./RequestCameraPermissionsPropsCmp.vue?vue&type=template&id=4bd6b3a2"
import script from "./RequestCameraPermissionsPropsCmp.vue?vue&type=script&lang=js"
export * from "./RequestCameraPermissionsPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__